import { kmsClient } from 'api';
import { useQuery } from '@apollo/react-hooks';
import { ARTICLE_QUERY } from './article.query';
import { getErrorsText, Severity, usePushNotifications } from 'services/NotificationService';
import { ArticleQuery, ArticleQueryVariables } from './__generated__/ArticleQuery';

export const useArticleQuery = (variables: ArticleQueryVariables) => {
  const notify = usePushNotifications();
  return useQuery<ArticleQuery, ArticleQueryVariables>(ARTICLE_QUERY, {
    variables,
    client: kmsClient,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    onError: (error) => notify({ title: 'Error', message: getErrorsText(error), severity: Severity.ERROR })
  });
};

// The article page reads its article cache-first and the cache is built with `addTypename: false`,
// so a mutation result is never normalized into this query. Patch it by hand after a star change,
// or leaving the page and coming back shows the star the article had on first load.
export const writeArticleStarredToCache = (variables: ArticleQueryVariables, starred: boolean) => {
  let cached: ArticleQuery | null = null;

  try {
    cached = kmsClient.readQuery<ArticleQuery, ArticleQueryVariables>({ query: ARTICLE_QUERY, variables });
  } catch {
    // Nothing cached for this article, so the next fetch brings the fresh value anyway.
    return;
  }

  if (!cached?.article) return;

  kmsClient.writeQuery<ArticleQuery, ArticleQueryVariables>({
    query: ARTICLE_QUERY,
    variables,
    data: { ...cached, article: { ...cached.article, starred } }
  });
};
